'use client'

import { useState } from 'react'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'

import RefundProgressModal from '../RefundProgressModal'

type Props = ConversationActionProps

const RefundProgress = ({ primary, title, inverse, theme, size }: Props) => {
  const { conversation } = useConversationContext()
  const transactionId = conversation?.transaction?.id

  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleConfirmationOpen = () => setIsModalOpen(true)

  const handleConfirmationClose = () => setIsModalOpen(false)

  if (!transactionId) return null

  return (
    <>
      <ConversationActionButton
        text={title}
        primary={primary}
        size={size}
        theme={theme}
        inverse={inverse}
        onClick={handleConfirmationOpen}
        testId="conversation-actions-refund-progress"
      />
      <RefundProgressModal
        isOpen={isModalOpen}
        onClose={handleConfirmationClose}
        transactionId={transactionId}
      />
    </>
  )
}

export default RefundProgress
